import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import AutoComplete from '@mui/material/Autocomplete';
import {Box} from '@mui/material';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function PharmPurchaseRequestEntry(props) {
    const [eqpitems, seteqpItems] = useState([]);
    const [eqprows, seteqprows] = useState([{id: '', product: '', qty: ''}]);
    const [dept, setDept] = useState([]);
    const [registerFormData, setRegisterFormData] = useState({
        "dept": '',
        "user": '',
        "status": '',
        "product": '',
        "qty": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        fetchPharmData();
        fetchData();
    }, []);
    function fetchPharmData() {
        axios.get(`${baseUrl}pharm-search/?totqty=gt0`)
            .then((pharmResponse) => {
                seteqpItems(pharmResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchData() {
        axios.get(`${baseUrl}add-dept/`)
            .then(response => {
                setDept(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleKeyDowneqp = (e, index) => {
        const neweqprows = [...eqprows];
        switch (e.keyCode) {
            // Handle Shift key
            case 16:
                e.preventDefault();
                if (index === eqprows.length - 1) {
                    neweqprows.push({id: '', product: '', qty: ''});
                }
                break;
            // Handle arrow up key
            case 38:
                e.preventDefault();
                if (neweqprows[index].selectedItemeqp === 0) {
                    neweqprows[index].selectedItemeqp = eqpitems.length - 1;
                } else {
                    neweqprows[index].selectedItemeqp--;
                }
                seteqprows(neweqprows);
                break;
            // Handle arrow down key
            case 40:
                e.preventDefault();
                if (neweqprows[index].selectedItemeqp === eqpitems.length - 1) {
                    neweqprows[index].selectedItemeqp = 0;
                } else {
                    neweqprows[index].selectedItemeqp++;
                }
                seteqprows(neweqprows);
                break;
            default:
                break;
        }
        seteqprows(neweqprows);
    };
    const handleSelecteqp = (val, index, id) => {
        const selectedItemeqp = val;
        const neweqprows = [...eqprows];
        neweqprows[index] = {
            id: selectedItemeqp.id,
            product: selectedItemeqp.product,
            qty: '',
        };
        seteqprows(neweqprows);
    };
    const handleAddRoweqp = () => {
        const neweqprows = [...eqprows];
        neweqprows.push({id: '', product: '', qty: ''});
        seteqprows(neweqprows);
    };
    const inputeqpRefs = useRef([]);
    useEffect(() => {
        inputeqpRefs.current[inputeqpRefs.current.length - 1]?.focus();
    }, [eqprows.length]);
    const handleDeleteRoweqp = (index) => {
        const neweqprows = [...eqprows];
        neweqprows.splice(index, 1);
        seteqprows(neweqprows);
    };
    const handleeqpChange = (event, index) => {
        const {name, value} = event.target;
        const neweqprows = [...eqprows];
        neweqprows[index][name] = value;
        const selectedItem = eqpitems.find(item => item.product === neweqprows[index].product);
        seteqprows(neweqprows);
    };
    const submitHandler = (e) => {
        e.preventDefault();
        if (!registerFormData.dept) {
            Swal.fire(
                'Error',
                'Please select a Department.',
                'error'
            );
            return;
        }
        if (!registerFormData.user) {
            Swal.fire(
                'Error',
                'Please enter Username.',
                'error'
            );
            return;
        }
        const validRows = eqprows.filter(
            row => row.id && row.qty && Number(row.qty) > 0
        );
        if (validRows.length === 0) {
            Swal.fire(
                'Error',
                'Please add atleast one item.',
                'error'
            );
            return;
        }
        axios.post(`${baseUrl}get-pharm-pr-no/`)
            .then(response => {
                const pr_no = response.data.value;
                const _formData = new FormData();
                // MAIN DATA
                _formData.append(
                    'dept',
                    registerFormData.dept
                );
                _formData.append(
                    'pr_no',
                    pr_no
                );
                _formData.append(
                    'requested_by',
                    registerFormData.user
                );
                _formData.append(
                    'status',
                    'Pending'
                );
                _formData.append(
                    'remarks',
                    ''
                );
                _formData.append(
                    'addedby',
                    userName
                );
                _formData.append(
                    'ip_add',
                    ipAddress
                );
                _formData.append(
                    'location',
                    userLocation
                );
                // ITEM DATA
                _formData.append(
                    'item_id',
                    validRows.map(
                        row => row.id
                    ).join(',')
                );
                _formData.append(
                    'hsn',
                    validRows.map(
                        row => row.hsn || ''
                    ).join(',')
                );
                _formData.append(
                    'product',
                    validRows.map(
                        row => row.product
                    ).join(',')
                );
                _formData.append(
                    'qty',
                    validRows.map(
                        row => row.qty
                    ).join(',')
                );
                _formData.append(
                    'approved_qty',
                    validRows.map(
                        row => 0
                    ).join(',')
                );
                _formData.append(
                    'item_remarks',
                    validRows.map(
                        row => ''
                    ).join(',')
                );
                axios.post(
                    `${baseUrl}pharm-purchase-request/`,
                    _formData
                )
                    .then(response => {
                        Swal.fire({
                            title: 'Purchase Request Created Successfully',
                            text: `PR No : ${pr_no}`,
                            icon: 'success',
                            timer: 4000,
                            showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href =
                                '/pharm-pur-req-list';
                        }, 2000);
                    })
                    .catch(error => {
                        console.log(
                            error.response?.data
                        );
                        Swal.fire(
                            'Error!',
                            'Failed to create Purchase Request.',
                            'error'
                        );
                    });
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to generate PR Number.',
                    'error'
                );
            });
    };
    const inputHandler = (event) => {
        const {name, value} = event.target;
        const updatedRegisterFormData = {...registerFormData, [name]: value};
        setRegisterFormData(updatedRegisterFormData);
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                Purchase Request Entry
            </h3>
            <div className="row">
                <div className="col-md-3 mb-3">
                    <label htmlFor="Dept" className="form-label">Department</label>
                    <select tabIndex={0} className="ms-2 me-3" name="dept" style={{width: 200}}
                            value={registerFormData.dept} onChange={inputHandler}>
                        <option>Choose Department</option>
                        {dept.map((department, index) => {
                            return <option key={index} value={department.id}>{department.department}
                            </option>
                        })}
                    </select>
                </div>
                <div className="col-md-3 mb-3">
                    <label htmlFor="Dept" className="form-label">Username</label>
                    <div style={{width: 200}}>
                        <input type="text" className="form-control" name="user" id="user" onChange={inputHandler}
                               placeHolder="User"
                               value={registerFormData.user}/>
                    </div>
                </div>
                <form>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th style={{width: 40}}>ID</th>
                                <th style={{width: 350}}>Product name</th>
                                <th style={{width: 130}}>QTY</th>
                                <th style={{width: 130}}>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {eqprows.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type="text"

                                            name="eqp_id"
                                            tabIndex={-1}
                                            value={row.id}
                                            onChange={handleeqpChange}
                                            readOnly
                                            style={{width: 90}}
                                        />
                                    </td>
                                    <td>
                                        <AutoComplete
                                            items={eqpitems}
                                            options={eqpitems}
                                            sx={{width: 500}}
                                            componentsProps={{
                                                paper: {
                                                    sx: {
                                                        width: 800
                                                    }
                                                }
                                            }}
                                            fullWidth
                                            onKeyDown={e => handleKeyDowneqp(e, index)}
                                            onChange={(event, val, id) => handleSelecteqp(val, index, id)}
                                            getOptionLabel={(option) => option ? option.product : ''}

                                            renderOption={(props, option) => (
                                                <Box component="li" {...props}
                                                     fullWidth
                                                     sx={{
                                                         width: 750,
                                                         height: 50,
                                                         borderRadius: 1,
                                                     }}
                                                >
                                                    {option.product ? `${option.product} ID: ${option.id} Expy: (${option.expiry}) MRP: ${option.mrp} Batch: ${option.batch}
                TQty: ${option.totqty} ` : ''}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <div ref={params.InputProps.ref}>
                                                    <input className="form-control" type="text" {...params.inputProps}
                                                           fullWidth focused autoFocus
                                                           style={{
                                                               background: "#F7EEFF",
                                                               width: 300,
                                                           }}
                                                    />
                                                </div>
                                            )}
                                            ref={(el) => inputeqpRefs.current[index] = el}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="ms-5 me-5"
                                            tabIndex={0}
                                            value={row.qty}
                                            name="qty"
                                            onChange={(e) => handleeqpChange(e, index)}
                                            onKeyDown={(e) => handleKeyDowneqp(e, index)}
                                            required
                                            style={{width: 200}}
                                        />
                                    </td>
                                    <td>
                                        <button className="btn btn-danger" type="button"
                                                onClick={() => handleDeleteRoweqp(index)}>Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRoweqp}>Add More
                    </button>
                    <div className="row">
                        <div className="col-md-12 text-center mb-5">
                            <button type="button" onClick={submitHandler} className="btn btn-success">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
}
export default PharmPurchaseRequestEntry;